module.exports = __webpack_public_path__ + "static/media/user-visor.e188a8db.svg";